import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { type Permission } from './permissions'
import { type FeatureToggle } from './featureToggles'

export const ippNavIntrospectAdminAccessControl: DomainAccessControlConfig = {}
